export default "__VITE_ASSET__23c1e586__"